module.exports = __webpack_public_path__ + "static/media/phone-screen.b2814ef7.png";